"use client";

import React from 'react';
import { Section } from '@/components/layout/Section';
import { TypographyH2, TypographyP } from '@/components/ui/typography';
import { ServiceSnapshotGrid } from '@/components/ui/service-snapshot-grid';

interface ServiceItem {
    title: string;
    description: string;
    href: string;
    cta: string;
    iconImageSrc?: string;
}

interface HomeServicesProps {
    title: string;
    description: string;
    services: ServiceItem[];
}

export function HomeServices({ title, description, services }: HomeServicesProps) {
    return (
        <Section className="bg-white py-12 md:py-20" id="services" fullWidth={true}>
            <div className="max-w-[1920px] mx-auto px-4">
                <div className="text-center mb-12 md:mb-16">
                    <TypographyH2 className="text-3xl md:text-4xl lg:text-[40px] font-medium text-secondary mb-4">
                        {title}
                    </TypographyH2>
                    <TypographyP className="text-lg md:text-xl lg:text-[24px] text-black max-w-[879px] mx-auto">
                        {description}
                    </TypographyP>
                </div>

                <div className="max-w-[1060px] mx-auto">
                    <ServiceSnapshotGrid
                        items={services}
                        variant="centered"
                    />
                </div>
            </div>
        </Section>
    );
}
